import { safeLocalStorage } from "@/lib/safeStorage";

/** Company name handed off from the marketing site (`/onboarding?shop=`). */
export const SHOP_STORAGE_KEY = "ruta_pending_shop_name";

export function shopNameFromSearch(search: string | URLSearchParams): string {
  const params =
    typeof search === "string"
      ? new URLSearchParams(search.startsWith("?") ? search.slice(1) : search)
      : search;
  return (params.get("shop") ?? "").trim();
}

export function rememberShopName(shopName: string): void {
  const trimmed = shopName.trim();
  if (!trimmed) return;
  safeLocalStorage.setItem(SHOP_STORAGE_KEY, trimmed);
}

export function recalledShopName(): string {
  return (safeLocalStorage.getItem(SHOP_STORAGE_KEY) ?? "").trim();
}

export function clearRememberedShopName(): void {
  safeLocalStorage.removeItem(SHOP_STORAGE_KEY);
}

/**
 * Prefer the live query string (the visitor just came from the site), then
 * whatever we stored so a later hop that drops `shop` still has the name.
 */
export function resolveShopName(search: string | URLSearchParams): string {
  return shopNameFromSearch(search) || recalledShopName();
}
